import { render, staticRenderFns } from "./TestimonialNavigation.vue?vue&type=template&id=bb71a6f6&scoped=true&"
import script from "./TestimonialNavigation.vue?vue&type=script&lang=js&"
export * from "./TestimonialNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb71a6f6",
  null
  
)

export default component.exports